import { fileObjectSchema } from './uploadSchema';
import type { FileObject } from './uploadToAWS';

export const isFileObject = (v: unknown): v is FileObject => {
  return fileObjectSchema.safeParse(v).success;
};
